import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useProfileSwitch } from "@/hooks/useProfileSwitch";
import { Eye, User, Loader2 } from "lucide-react";

export const ProfileSwitchButton = () => {
  const { activeProfile, switchProfile, loading, isDemoUser } = useProfileSwitch();
  const [isDemo, setIsDemo] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkDemoUser = async () => {
      try {
        const demo = await isDemoUser();
        setIsDemo(demo);
      } catch (error) {
        console.error('Error checking demo user:', error);
        setIsDemo(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkDemoUser();
  }, [isDemoUser]);

  if (isLoading) return null;
  if (!isDemo) return null;
  if (!activeProfile) return null;

  return (
    <div className="flex items-center gap-2">
      <Badge 
        variant={activeProfile === 'demo' ? 'default' : 'secondary'}
        className="text-xs"
      >
        {activeProfile === 'demo' ? 'Admin View' : 'Aluno View'}
      </Badge>
      
      <Button
        variant="outline"
        size="sm"
        onClick={() => switchProfile(activeProfile === 'demo' ? 'aluno' : 'demo')}
        disabled={loading}
        className="h-8 px-3 text-xs"
      >
        {loading ? (
          <Loader2 className="h-3 w-3 animate-spin" />
        ) : activeProfile === 'demo' ? (
          <>
            <User className="h-3 w-3 mr-1" />
            Ver como Aluno
          </>
        ) : (
          <>
            <Eye className="h-3 w-3 mr-1" />
            Ver como Admin
          </>
        )}
      </Button>
    </div>
  );
};
